import { useLineItem } from "@models/interactions/use-line-item";
import {
  Link,
  CartLinePrice,
  Image,
} from "@shopify/hydrogen";
import { CloseIcon } from "@components/atoms/Icons";
import { translate } from "@locales";
import { usePostRequest } from "@models/interactions/get-single-product";
import { LineItemPageMobile } from "./line-item-mobile.client";
import classNames from "classnames";
import { CartLineItem } from "@models/interactions/cart-line-quantity-adjust";


function useLineItemPage() {
  const {
    models: { merchandise, lineId, quantity },
    operations: { linesRemove },
  } = useLineItem();
  const isReward = merchandise?.priceV2?.amount === "0.0";
  const barcode = usePostRequest(
    `api/single-product?handle=${merchandise.product.handle}`
  );

  return {
    models: {
      merchandise,
      lineId,
      quantity,
      isReward,
      barcode,
    },
    operations: {
      linesRemove,
    },
  };
}
export function LineItemPage() {
  const { models, operations } = useLineItemPage();
  return (
    <>
      <LineItemPageMobile />
      <div
        key={models.lineId}
        className="hidden md:grid grid-rows-1 grid-cols-3 items-center md:grid-cols-[100px_500px_1fr_min-content_1fr] md:grid-row-1 border-b pb-[3.75rem] pt-[3.6875rem]"
      >
        <div className="flex">
          <button
            type="button"
            onClick={() => operations.linesRemove([models.lineId])}
            className="justify-self-start p-1 -mr-1 disabled:cursor-not-allowed"
            disabled={models.isReward}
          >
            <CloseIcon className="font-medium" width="18" height="18" />
          </button>
          <Image
            data={models?.merchandise?.image!}
            className="object-cover object-center w-[70px] h-[70px]"
            alt="product image"
          />
        </div>
        <div className="pl-[1.8125rem]">
          <h3 className="font-medium uppercase">
            <Link to={`/products/${models.merchandise.product.handle}`}>
              {models.merchandise.product.title}
            </Link>
          </h3>
          <div className="text-dark-gray text-xs font-chivo-regular">
            <span>
              # {translate("shop.product.item")}: {models.barcode}
            </span>
          </div>
          <div>
            {models.merchandise.availableForSale ? (
              <span className="text-custom-yellow text-xs font-chivo-bold">
                {" "}
                {translate("shop.filter.availability.in-stock")}
              </span>
            ) : (
              ""
            )}
          </div>
        </div>
        <span className="text-dark-gray text-base font-chivo-regular pl-3">
          {models.merchandise.priceV2.amount}
        </span>
        <div
          className={classNames("flex items-center gap-2", {
            "pointer-events-none bg-gray-200 backdrop-opacity-40 ":
              models.isReward,
          })}
        >
          <CartLineItem />
        </div>
        <CartLinePrice
          as="span"
          className="text-black font-chivo-regular font-medium text-xl tracking-wider pl-[30px]"
        />
      </div>
    </>
  );
}
